<app-page-title icon="fa-sliders" title="Domínio Próprio — Configurações"></app-page-title>

<div class="row" *ngIf="!loading">
  <div class="col-12 col-lg-10 offset-lg-1">

    <!-- preços-base do add-on -->
    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title">Preços do add-on</h5>
        <p class="text-muted">
          <strong>Preço de venda</strong> é o que o cliente paga; <strong>repasse estimado</strong> é o custo
          informado aqui, <strong>em reais</strong>; a <strong>margem</strong> é calculada. Alterações valem
          imediatamente para novas cobranças — contratos já pagos não mudam.
        </p>
        <p class="text-muted small">
          <i class="fa fa-info-circle"></i>
          Este repasse é um valor <strong>digitado</strong>, não a cotação do registrador: o custo real de cada
          compra é gravado <strong>por domínio</strong>, na moeda do registrador (US$). A margem desta tela é,
          portanto, uma estimativa em BRL — não a margem realizada.
        </p>

        <div class="table-responsive">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th>Item</th>
                <th class="text-end">Repasse estimado (R$)</th>
                <th class="text-end">Preço de venda (R$)</th>
                <th class="text-end">Margem (R$)</th>
                <th class="text-center">Ativo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let price of basePrices">
                <td>{{ label(price) }}</td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         [(ngModel)]="price.cost" />
                </td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         [(ngModel)]="price.price" />
                </td>
                <td class="text-end">{{ margin(price).toFixed(2).replace('.', ',') }}</td>
                <td class="text-center">
                  <input type="checkbox" class="form-check-input" [(ngModel)]="price.active" />
                </td>
                <td class="text-end">
                  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm"
                          [appLoadingButton]="busyKey === 'save-' + price.id" [disabled]="working" (click)="save(price)">
                    <i class="fa fa-save"></i> Salvar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- TLDs do fluxo Compra -->
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Extensões (TLDs) — fluxo Compra</h5>
        <p class="text-muted">
          Preço de venda do registro anual por extensão, somado à assinatura no checkout da Compra.
          Extensão sem preço cadastrado (ou inativa) fica indisponível para compra.
        </p>

        <div class="table-responsive">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th>TLD</th>
                <th class="text-end">Repasse estimado (R$)</th>
                <th class="text-end">Preço de venda (R$)</th>
                <th class="text-end">Margem (R$)</th>
                <th class="text-center">Ativo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let price of tlds">
                <td><code>.{{ price.tld }}</code></td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         [(ngModel)]="price.cost" />
                </td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         [(ngModel)]="price.price" />
                </td>
                <td class="text-end">{{ margin(price).toFixed(2).replace('.', ',') }}</td>
                <td class="text-center">
                  <input type="checkbox" class="form-check-input" [(ngModel)]="price.active" />
                </td>
                <td class="text-end text-nowrap">
                  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm sf-btn--icon me-1" aria-label="Salvar"
                          [appLoadingButton]="busyKey === 'save-' + price.id" [disabled]="working" (click)="save(price)">
                    <i class="fa fa-save"></i>
                  </button>
                  <button type="button" class="sf-btn sf-btn--danger sf-btn--sm sf-btn--icon" aria-label="Excluir"
                          [appLoadingButton]="busyKey === 'remove-' + price.id" [disabled]="working" (click)="removeTld(price)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>

              <!-- linha de cadastro -->
              <tr>
                <td>
                  <input type="text" class="form-control form-control-sm" placeholder="com.br"
                         [(ngModel)]="newTld.tld" (keyup.enter)="addTld()" />
                </td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         placeholder="custo" [(ngModel)]="newTld.cost" />
                </td>
                <td class="text-end">
                  <input type="number" min="0" step="0.01" class="form-control form-control-sm price-input"
                         placeholder="venda" [(ngModel)]="newTld.price" />
                </td>
                <td></td>
                <td></td>
                <td class="text-end">
                  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm"
                          [appLoadingButton]="busyKey === 'add'" [disabled]="working" (click)="addTld()">
                    <i class="fa fa-plus"></i> Adicionar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Esqueleto das duas tabelas (CU-86akkubzz): a tela saiu do overlay global. -->
<div class="row" *ngIf="loading" data-testid="dominio-precos-loading">
  <div class="col-12 col-lg-10 offset-lg-1">
    <app-skeleton variant="table-row" [count]="6" [columns]="6" label="Carregando os preços"></app-skeleton>
  </div>
</div>
